import { mcIntlContextGuard } from '@mc/internationalization/McIntlContext';
import { useTranslateMessage } from '@mc/internationalization/translationUtils';

export function useDsTranslateMessage(translationObj) {
  return mcIntlContextGuard()(useTranslateMessage)(translationObj);
}
